import axios from "axios";
import { server } from "../config/key.js";

const token = localStorage.getItem("token");

export const userInstance = axios.create({
  baseURL: `${server}/v1/users`,
  headers: { Authorization: token },
});

export const authInstance = axios.create({
  baseURL: `${server}/v1/auth`,
  headers: {
    Authorization: token,
  },
});
export const withoutAuthInstance = axios.create({
  baseURL: `${server}/v1`,
  // headers: {
  //   Authorization: token,
  // },
});
console.log('process.env.GHL_TOKEN--->',process.env.GHL_TOKEN);
export const goHighLevelContactInstance = axios.create({
  baseURL: `https://rest.gohighlevel.com/v1`,
  headers: {
    Authorization: `Bearer ${process.env.GHL_TOKEN}`,
    version: '2021-04-15'
  },
});

export const goHighLevelUserInstance = axios.create({
  baseURL: `https://rest.gohighlevel.com/v1`,
  headers: {
    Authorization: `Bearer ${process.env.GHL_TOKEN}`,
    version: '2021-04-15'
  },
});